module.exports = __webpack_public_path__ + "static/media/7B.e50da8fa.jpg";